import React from 'react';
import {FormattedMessage} from "react-intl";

import {getShippingMethodName} from "./getShippingMethodName";
import {toArray} from "./toArray";

// mirrors Shipment::NO_TRACKING_NUMBER on the back (api/src/Entity/Shipment.php) - set on
// click & collect shipments that never get a real carrier tracking number
export const NO_TRACKING_NUMBER = 'no-tracking';

// a shipment either has its own trackingNumber, or is split into parcels
// each carrying their own trackingNumber - never both
function getTrackingNumbersForShipment(shipment) {
    const tooltip = (
        <FormattedMessage
            id="oms.order.trackingNumbers.shipment"
            values={{shippingMethodName: getShippingMethodName(shipment.shippingMethod)}}
        />
    );

    if (shipment.trackingNumber && shipment.trackingNumber !== NO_TRACKING_NUMBER) {
        return [{trackingNumber: shipment.trackingNumber, tooltip}];
    }

    return (shipment.parcels || [])
        .filter((parcel) => parcel.trackingNumber && parcel.trackingNumber !== NO_TRACKING_NUMBER)
        .map((parcel) => ({trackingNumber: parcel.trackingNumber, tooltip}));
}

export function getShipmentTrackingNumbers(shipments) {
    return toArray(shipments).flatMap(getTrackingNumbersForShipment);
}
